<template>
    <div class="d-flex align-items-center mt-md-n2" v-if="did">
        <blockie :address="did" v-if="show_blockie"/>
        <p :class="{'mt-3 m-l-10': show_blockie}">
            <router-link :to="{name: 'view-member', params: {catalogid: catalog, memberid: did}}">{{short_name}}
            </router-link>
        </p>
    </div>
</template>

<script>
    import Blockie from "../common/Blockie.vue";

    export default {
        name: "DidDetails",
        components: {Blockie},
        props: ['did', 'catalog', 'show_blockie'],
        watch: {
            did: function (nv, ov) {
                if (nv) {
                    this.getDid();
                }
            }
        },
        data() {
            return {
                short_name: null
            }
        },
        mounted() {
            this.getDid();
        },
        methods: {
            async getDid() {
                try {
                    let {data} = await this.$identity.get(`/identity/catalogs/${this.catalog}/dids/${this.did}`);
                    this.short_name = data ? data.short_name : null;
                } catch (e) {
                }
            }
        }
    }
</script>

<style scoped>

</style>
